/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Question_CitationsInputs */

const en_faq_question_citations = /** @type {(inputs: Faq_Question_CitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I don't want to listen to all the references and citations. Can your app skip those?`)
};

const es_faq_question_citations = /** @type {(inputs: Faq_Question_CitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No quiero escuchar todas las referencias y citas. ¿Puede tu app omitirlas?`)
};

/**
* | output |
* | --- |
* | "I don't want to listen to all the references and citations. Can your app skip those?" |
*
* @param {Faq_Question_CitationsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const faq_question_citations = /** @type {((inputs?: Faq_Question_CitationsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Question_CitationsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_faq_question_citations(inputs)
	return en_faq_question_citations(inputs)
});